/**
 * Keys that must survive an organization switch: app lifecycle flags
 * (service worker / chunk recovery) and the marking portal kiosk session.
 */
const PRESERVED_KEY_PREFIXES = ['guarnic', 'markingPortal.'];

const isPreservedKey = (key: string): boolean =>
  PRESERVED_KEY_PREFIXES.some(prefix => key.startsWith(prefix));

/**
 * Drops every persisted list/dashboard view state (filters, sort, pagination)
 * so a new organization starts from its defaults instead of inheriting ids,
 * divisions or users that do not exist in it.
 */
export const clearPersistedViewState = (): void => {
  const { sessionStorage } = window;
  if (!sessionStorage) return;

  Object.keys(sessionStorage)
    .filter(key => !isPreservedKey(key))
    .forEach(key => sessionStorage.removeItem(key));
};
